import {
    useFormAddonGroup,
    useFormUnregisterField,
} from '@/features/pos/components/ProductConfigurationModal/form'
import { FormKeys } from '@/features/pos/components/ProductConfigurationModal/form/constants'
import { useUpdateNonRepeatableAddon } from '@/features/pos/components/ProductConfigurationModal/parts/AddonGroup/hooks/useUpdateNonRepeatableAddon'
import OptionItem from '@/features/pos/components/ProductConfigurationModal/parts/OptionGroup/parts/OptionItem'
import { AddonGroup } from '@/features/pos/components/ProductConfigurationModal/types'
import { FC } from 'react'

interface NonRepeatableAddonListProps {
    addonGroup: AddonGroup
}

const NonRepeatableAddonList: FC<NonRepeatableAddonListProps> = ({ addonGroup }) => {
    const [formAddonGroup, onChange] = useFormAddonGroup(addonGroup)

    useFormUnregisterField(`${FormKeys.AddonGroups}.${addonGroup.id}`)

    const updateAddon = useUpdateNonRepeatableAddon(addonGroup, formAddonGroup, onChange)

    return (
        <>
            {addonGroup.addons.map((addon) => (
                <OptionItem
                    key={addon.id}
                    id={addon.id}
                    selected={!!formAddonGroup?.addonQuantities[addon.id]}
                    disabled={addon.soldOut}
                    name={addon.name}
                    price={addon.price}
                    onPress={updateAddon}
                />
            ))}
        </>
    )
}

export default NonRepeatableAddonList
